import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { ManualesService } from "../servicios/manuales.service";
import { HttpClient } from '@angular/common/http';
import { EliminarManualData } from '../entidades/entidades.component';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-eliminar-manual',
    templateUrl: './eliminar-manual.component.html',
    styleUrls: ['./eliminar-manual.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule],
})
export class EliminarManualComponent implements OnInit {
  @Input() public data: EliminarManualData;
  durationInSeconds = 2;
  showSpinner: boolean = false;
  idCliente: number;

  constructor(public dialogRef: NbDialogRef<EliminarManualComponent>,
    private _snackBar: MatSnackBar, private http: HttpClient,
    private svcManuales: ManualesService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
  }

  eliminarArchivo() {
    this.showSpinner = true;
    this.svcManuales.deleteManual(this.data.idManual).subscribe(data => {
      if (data["status"] == 204) {
        this.showSpinner = false;
        this.openSnackBar('Se eliminó correctamente');
        this.closeDialog();
      } else {
        this.showSpinner = false;
        this.openSnackBar('Ocurrió un error');
        this.closeDialog();
      }
    })
  }

  closeDialog(){
    this.dialogRef.close()
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    })
  }

}
